var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Button',_vm._b({staticClass:"ButtonIcon",attrs:{"to":_vm.to,"href":_vm.href},on:{"click":function($event){return _vm.$emit('click')}}},'Button',_vm.$attrs,false),[_c('Icon',{attrs:{"name":_vm.icon}}),_c('span',[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }